export default {
  depthHistory: [],
  token: '',
  userName: '',
  bindTicket: '',
  bookingContactInfo: null,
  goodsCartNum: 0,
  smCartNum: 0,
  indexPopupMessageLoaded: false,
  bookingPage: '',
  isMiniApp: false,
  isFromPcpMiniProgram: false,
  isMaskValue: true,
  showCartCancelOrder: false,
  isCheckShorex: false,
  userCoupon: null,
  isFirstLogin: false,
  commonInfo: null,
  homePcpBindCouponInfo: null
}
